import ConfidentialJobsList from './ConfidentialJobsList';

export default ConfidentialJobsList;